export enum UnifiedJobStatus {
    Pending,
    Processing,
    Success,
    Error
}

export interface JobAdapter<TJob> {    
    getId(job: TJob): string;
    getStatus(status: TJob): UnifiedJobStatus;
    getProjectId(job: TJob): string;
    getFileNameResult?(job: TJob): string;
}